export default __webpack_public_path__ + "static/insight-screenshot-4ad5e62cc526f5a99201bda7126781ba.png";